/**
 * `email` → **Settings** (spec M2 tier-2 §5.9, card P-123).
 *
 * No *Customize Email column* row exists in the captured `Settings` submenu
 * (`editors/email/settings-menu.json`), and yet the type stores two keys `[09§A.7 email]`, both
 * about the mail monday composes when the address is clicked: `includePulseInSubject` puts the
 * item's name in the subject line, and `ccPulse` copies the item's update thread so the reply
 * lands back on the board.
 *
 * Neither is *acted on* here — this product opens `mailto:` and sends no mail itself — so both
 * round-trip monday's key and change nothing yet. q523.
 */
import type { EmailSettings } from '@elizmonday/shared';
import {
  HideSummaryField,
  SettingsCheckbox,
  SettingsForm,
  useSettingsDraft,
} from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function EmailSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<EmailSettings>) {
  const [draft, patch] = useSettingsDraft<EmailSettings>(settings);
  return (
    <SettingsForm
      title="Email column settings"
      testId="email-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <SettingsCheckbox
        label="Include the item name in the subject"
        testId="email-include-item"
        checked={draft.includePulseInSubject ?? false}
        onChange={(next) => patch({ includePulseInSubject: next })}
      />
      <SettingsCheckbox
        label="Copy the item's updates on the email"
        testId="email-cc-item"
        checked={draft.ccPulse ?? false}
        onChange={(next) => patch({ ccPulse: next })}
      />
      <HideSummaryField
        testId="email-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
